import { Link, Outlet } from '@tanstack/react-router';
import { useCurrentIdentity } from '@/lib/identity-context';

export function AppShell() {
  const { me, hasPermission } = useCurrentIdentity();
  const canRunHarness = hasPermission('harness:run');
  const canObservePlatform = hasPermission('platform:observe');
  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex items-center justify-between border-b px-6 py-3">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <img src="/logo-lockup.svg" alt="TrackerCop" className="h-7 w-auto" />
            <span className="rounded-md bg-muted px-2 py-0.5 text-xs text-muted-foreground">
              {me.activeTenant.name}
            </span>
          </Link>
          {canRunHarness && (
            <Link
              to="/harness"
              className="text-xs text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
              data-testid="nav-harness-link"
            >
              Harness
            </Link>
          )}
          {canObservePlatform && (
            <Link
              to="/admin/observability"
              className="text-xs text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
              data-testid="nav-admin-observability-link"
            >
              Admin → Observability
            </Link>
          )}
        </div>
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <span>{me.user.email}</span>
          <a className="underline underline-offset-4" href="/cdn-cgi/access/logout">
            Log out
          </a>
        </div>
      </header>
      <main className="flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
}
